const RING_SIZER_CATEGORIES = [
  'Rings',
  'PreSet Solitaire Rings',
  'Bangles',
  'Thumb Rings',
  'Midi Rings',
];

const CHAIN_SIZER_CATEGORIES = ['Mangalsutra Chains', 'Chains'];

const SIZER_EXCLUDED_CATEGORIES = ['Bracelets', 'Necklaces', 'Anklets'];

export function shouldShowRingSizerLink(category: string): boolean {
  return RING_SIZER_CATEGORIES.includes(category);
}

export function shouldShowChainSizerLink(category: string): boolean {
  return CHAIN_SIZER_CATEGORIES.includes(category);
}

export function isSizerLinkVisible(category: string, isSizerEnabled: boolean, hasSize: boolean): boolean {
  if (!isSizerEnabled || !hasSize) return false;
  if (SIZER_EXCLUDED_CATEGORIES.includes(category)) return false;
  return shouldShowRingSizerLink(category) || shouldShowChainSizerLink(category);
}

export function getSizerLinkLabel(category: string): string {
  return shouldShowChainSizerLink(category) ? 'Not sure of the length?' : 'Not sure of the size?';
}
